import { css } from "styled-components";
import { Option } from "../../";
export const riotProductSkinSelectContent = (chroma, paletteTokens) => css `
  z-index: ${chroma.dimensions.dropdownZIndex};

  & > div {
    overflow: hidden;
    background-color: #333;
    box-shadow:
      0 10px 38px -10px rgb(22 23 24 / 35%),
      0 10px 20px -15px rgb(22 23 24 / 20%);
    width: 100%;
    max-width: 512px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  & .SelectViewport {
    padding: 5px;
  }

  ${Option} {
    ${chroma.typography.body3};
    color: #ece8e1;
    border-radius: 3px;
    display: flex;
    align-items: center;
    height: 30px;
    padding: 0 35px 0 25px;
    position: relative;
    user-select: none;
  }

  ${Option}[data-disabled] {
    color: #908572;
    pointer-events: none;
  }

  ${Option}[data-highlighted] {
    outline: none;
    background-color: ${paletteTokens.bladebg2};
  }

  ${Option}[data-state="checked"] {
    outline: none;
    background-color: ${paletteTokens.bladebg2};
  }
`;
//# sourceMappingURL=select-content.js.map